import React from "react";
import { useRouter } from "next/dist/client/router";
import { useQuery } from "@apollo/client";
import { USER_INFO } from "../../../gql/user";

function RequiredFillData(props) {
  const router = useRouter();

  const { data } = useQuery(USER_INFO);

  React.useEffect(() => {
    if (data) {
      const checkValidAttr = {
        address: data.me.address,
        city: data.me.city,
        city: data.me.city,
        country: data.me.country,
        email: data.me.email,
        name: data.me.name,
        phone: data.me.phone,
        postal_code: data.me.postal_code,
        province: data.me.province,
      };
      if (
        Object.values(checkValidAttr).filter((val) => val === "").length !== 0
      ) {
        router.push("/myprofile");
      }
    }
  }, [router, data]);

  return props.children;
}

export default RequiredFillData;
